import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
const baseUrl = publicRuntimeConfig.baseUrl;

export const config = {
  popularLocations: [
    {
      label: 'ทองหล่อ - พระโขนง',
      link: `${baseUrl}list/ทำเล-ย่าน/ทองหล่อ-พระโขนง/`,
    },
    {
      label: 'อ่อนนุช - ปุณณวิถี',
      link: `${baseUrl}list/ทำเล-ย่าน/อ่อนนุช-ปุณณวิถี/`,
    },
    {
      label: 'อโศก - พร้อมพงษ์',
      link: `${baseUrl}list/ทำเล-ย่าน/อโศก-พร้อมพงษ์/`,
    },
    {
      label: 'ลาดพร้าว',
      link: `${baseUrl}list/ทำเล-ย่าน/ลาดพร้าว/`,
    },
    {
      label: 'เพชรบุรี - พระราม 9',
      link: `${baseUrl}list/ทำเล-ย่าน/เพชรบุรี-พระราม-9/`,
    },
    {
      label: 'รัชดาภิเษก - ห้วยขวาง',
      link: `${baseUrl}list/ทำเล-ย่าน/รัชดาภิเษก-ห้วยขวาง/`,
    },
    {
      label: 'อารีย์ - หมอชิต',
      link: `${baseUrl}list/ทำเล-ย่าน/อารีย์-หมอชิต/`,
    },
    {
      label: 'พญาไท - สามย่าน',
      link: `${baseUrl}list/ทำเล-ย่าน/พญาไท-สามย่าน/`,
    },
    {
      label: 'พัทยา',
      link: `${baseUrl}list/ทำเล-ย่าน/ภาคตะวันออก/พัทยา/`,
    },
    {
      label: 'ชลบุรี',
      link: `${baseUrl}list/ทำเล-ย่าน/ภาคตะวันออก/ชลบุรี/`,
    },
    {
      label: 'หัวหิน',
      link: `${baseUrl}list/ทำเล-ย่าน/ภาคใต้และตะวันตก/หัวหิน/`,
    },
    {
      label: 'ชะอำ',
      link: `${baseUrl}list/ทำเล-ย่าน/ภาคใต้และตะวันตก/ชะอำ/`,
    },
  ],
  popularDevelopers: [
    {
      label: 'Sansiri (แสนสิริ)',
      link: `${baseUrl}tag/sansiri/`,
    },
    {
      label: 'SC Asset (เอสซี แอสเสท)',
      link: `${baseUrl}tag/sc-asset/`,
    },
    {
      label: 'Supalai (ศุภาลัย)',
      link: `${baseUrl}tag/supalai/`,
    },
    {
      label: 'Q.House (คิวเฮ้าส์)',
      link: `${baseUrl}tag/q-house/`,
    },
    {
      label: 'Ananda Development (อนันดา)',
      link: `${baseUrl}tag/ananda/`,
    },
    {
      label: 'AP Thailand (เอพี ไทยแลนด์)',
      link: `${baseUrl}tag/ap/`,
    },
    {
      label: 'AQ Estate (เอคิว เอสเตท)',
      link: `${baseUrl}tag/aq/`,
    },
    {
      label: 'Chewathai (ชีวาทัย)',
      link: `${baseUrl}tag/ชีวาทัย/`,
    },
    {
      label: 'Land & Houses (แลนด์แอนด์เฮ้าส์)',
      link: `${baseUrl}tag/lh/`,
    },
    {
      label: 'Lalin Property (ลลิล)',
      link: `${baseUrl}tag/lalin-property/`,
    },
    {
      label: 'LPN (ลุมพินี)',
      link: `${baseUrl}tag/lpn-ลุมพินี/`,
    },
    {
      label: 'Property Perfect (พร็อพเพอร์ตี้ เพอร์เฟค)',
      link: `${baseUrl}tag/pf/`,
    },
    {
      label: 'Pruksa (พฤกษา)',
      link: `${baseUrl}tag/pruksa/`,
    },
    {
      label: 'Noble Development(โนเบิล ดีเวลลอปเม้นท์ )',
      link: `${baseUrl}tag/โนเบิล/`,
    },
    {
      label: 'Narai Property (นารายณ์ พร็อพเพอตี้)',
      link: `${baseUrl}tag/narai-property/`,
    },
    {
      label: 'Origin Property (ออริจิ้น)',
      link: `${baseUrl}tag/origin-property/`,
    },
    {
      label: 'Sena Development (เสนา)',
      link: `${baseUrl}tag/sena/`,
    },
    {
      label: 'Raimon Land (ไรมอน แลนด์)',
      link: `${baseUrl}tag/raimon/`,
    },
    {
      label: 'V Property (วี พร็อพเพอร์ตี้)',
      link: `${baseUrl}tag/v-property/`,
    },
    {
      label: 'Frasers Property (เฟรเซอร์ส)',
      link: `${baseUrl}tag/frasers-property/`,
    },
    {
      label: 'CMC (เจ้าพระยา)',
      link: `${baseUrl}tag/cmc/`,
    },
    {
      label: 'MQDC (เอ็มคิวดีซี)',
      link: `${baseUrl}tag/mqdc/`,
    },
    {
      label: 'M.K. Real Estate (มั่นคง)',
      link: `${baseUrl}tag/มั่นคงเคหะการ/`,
    },
    {
      label: 'Major Development (เมเจอร์)',
      link: `${baseUrl}tag/major-development/`,
    },
    {
      label: 'Grand Unity (แกรนด์ยูนิตี้)',
      link: `${baseUrl}tag/grand-u/`,
    },
    {
      label: 'Prinsiri (ปริญสิริ)',
      link: `${baseUrl}tag/prin/`,
    },
    {
      label: 'Eastern Star (อีสเทอร์น สตาร์)',
      link: `${baseUrl}tag/eastern-star-2/`,
    },
    {
      label: 'AssetWise (แอสเซทไวส์)',
      link: `${baseUrl}tag/asset-wise-2/`,
    },
    {
      label: 'TC Development',
      link: `${baseUrl}tag/tc-development/`,
    },
    {
      label: 'Singha Estate (สิงห์ เอสเตท)',
      link: `${baseUrl}tag/singha-estate/`,
    },
    {
      label: 'CPN Residence (ซีพีเอ็น เรสซิเดนซ์ )',
      link: `${baseUrl}tag/cpn/`,
    },
    {
      label: 'Siamese Asset (ไซมิส)',
      link: `${baseUrl}tag/siamese-asset/`,
    },
  ],
  popularSearchTerms: [
    {
      label: 'บ้านเดี่ยว บ้านแฝด',
      link: `${baseUrl}บ้าน/`,
    },
    {
      label: 'คอนโดติดรถไฟฟ้า',
      link: `${baseUrl}list/รถไฟฟ้า/คอนโด/`,
    },
    {
      label: 'โครงการบ้านใหม่',
      link: `${baseUrl}tag/preview/`,
    },
    {
      label: 'ซื้อบ้าน-ขายบ้าน',
      link: `${baseUrl}tag/guides/`,
    },
    {
      label: 'คอนโดมิเนียม',
      link: `${baseUrl}คอนโด/`,
    },
    {
      label: 'คอนโดติด BTS',
      link: `${baseUrl}list/รถไฟฟ้า/bts-สายสีเขียวอ่อน/คอนโด/`,
    },
    {
      label: 'บ้านพร้อมอยู่',
      link: `${baseUrl}tag/review/`,
    },
    {
      label: 'เช่าบ้าน-ปล่อยเช่า',
      link: `${baseUrl}tag/เช่า/`,
    },
    {
      label: 'ทาวน์โฮม',
      link: `${baseUrl}ทาวน์โฮม/`,
    },
    {
      label: 'คอนโดติด MRT',
      link: `${baseUrl}list/รถไฟฟ้า/mrt-สายสีน้ำเงิน/คอนโด/`,
    },
    {
      label: 'คอนโดพร้อมอยู่',
      link: `${baseUrl}tag/condominium-review/`,
    },
    {
      label: 'ตกแต่งบ้าน-แบบบ้าน',
      link: `${baseUrl}tag/living-idea/`,
    },
    {
      label: 'โฮมออฟฟิศ (home office)',
      link: `${baseUrl}โฮมออฟฟิศ/`,
    },
    {
      label: 'คอนโดติด Airport link',
      link: `${baseUrl}list/รถไฟฟ้า/airport-rail-link/คอนโด/`,
    },
    {
      label: 'บ้านมือสอง',
      link: `${baseUrl}tag/บ้านมือสอง/`,
    },
    {
      label: 'โปรโมชั่นบ้าน-คอนโด',
      link: `${baseUrl}events/fast-deal-living-expo-2020/`,
    },
  ],
  popularSegments: [
    {
      label: 'บ้านราคาไม่เกิน 3 ล้าน',
      link: `${baseUrl}list/บ้าน/ราคาสูงสุด-3ล้าน/`,
    },
    {
      label: 'คอนโดราคาไม่ถึงล้าน',
      link: `${baseUrl}list/คอนโด/ราคาสูงสุด-1ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคาไม่เกิน 3 ล้าน',
      link: `ps://thinkofliving.com/list/ทาวน์โฮม/ราคาสูงสุด-3ล้าน/`,
    },
    {
      label: 'Super Economy (ต่ำกว่า 50,000 บาท / ตรม.)',
      link: `${baseUrl}tag/super-economy-class/`,
    },
    {
      label: 'บ้านราคา 3-5 ล้าน',
      link: `${baseUrl}list/บ้าน/3ล้าน-5ล้าน/`,
    },
    {
      label: 'คอนโดราคา 1-3 ล้าน',
      link: `${baseUrl}list/คอนโด/1ล้าน-3ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคา 3-5 ล้าน',
      link: `${baseUrl}list/ทาวน์โฮม/3ล้าน-5ล้าน/`,
    },
    {
      label: 'Economy (50,000 - 70,000 บาท / ตรม.)',
      link: `${baseUrl}tag/economy-class/`,
    },
    {
      label: 'บ้านราคา 5-7  ล้าน',
      link: `${baseUrl}list/บ้าน/5ล้าน-7ล้าน/`,
    },
    {
      label: 'คอนโดราคา 5-7  ล้าน',
      link: `${baseUrl}list/คอนโด/5ล้าน-7ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคา 5-7  ล้าน',
      link: `${baseUrl}list/ทาวน์โฮม/5ล้าน-7ล้าน/`,
    },
    {
      label: 'Main Class (70,000 - 100,000 บาท / ตรม.)',
      link: `${baseUrl}tag/main-class/`,
    },
    {
      label: 'บ้านราคา 7-10 ล้าน',
      link: `${baseUrl}list/บ้าน/7ล้าน-10ล้าน/`,
    },
    {
      label: 'คอนโดราคา 7-10 ล้าน',
      link: `${baseUrl}list/คอนโด/7ล้าน-10ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคา 7-10 ล้าน',
      link: `${baseUrl}list/ทาวน์โฮม/7ล้าน-10ล้าน/`,
    },
    {
      label: 'Upper Class (100,000 - 150,000 บาท / ตรม.)',
      link: `${baseUrl}tag/upper-class/`,
    },
    {
      label: 'บ้านราคา 10-15 ล้าน',
      link: `${baseUrl}list/บ้าน/10ล้าน-15ล้าน/`,
    },
    {
      label: 'คอนโดราคา 10-15 ล้าน',
      link: `${baseUrl}list/คอนโด/10ล้าน-15ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคา 10-15 ล้าน',
      link: `${baseUrl}list/ทาวน์โฮม/10ล้าน-15ล้าน/`,
    },
    {
      label: 'high Class (150,000 - 200,000 บาท / ตรม.)',
      link: `${baseUrl}tag/high-class/`,
    },
    {
      label: 'บ้านราคา 15-30 ล้าน',
      link: `${baseUrl}list/บ้าน/15ล้าน-30ล้าน/`,
    },
    {
      label: 'คอนโดราคา 15-30 ล้าน',
      link: `${baseUrl}list/คอนโด/15ล้าน-30ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคา 15-30 ล้าน',
      link: `${baseUrl}list/ทาวน์โฮม/15ล้าน-30ล้าน/`,
    },
    {
      label: 'Luxury (200,000 - 300,000 บาท / ตรม.)',
      link: `${baseUrl}tag/luxury-class/`,
    },
    {
      label: 'บ้านราคา 30 ล้านขึ้นไป',
      link: `${baseUrl}list/บ้าน/ราคาต่ำสุด-30ล้าน/`,
    },
    {
      label: 'คอนโดราคา 30 ล้านขึ้นไป',
      link: `${baseUrl}list/คอนโด/ราคาต่ำสุด-30ล้าน/`,
    },
    {
      label: 'ทาวน์โฮมราคา 30 ล้านขึ้นไป',
      link: `${baseUrl}list/ทาวน์โฮม/ราคาต่ำสุด-30ล้าน/`,
    },
    {
      label: 'Super Luxury (มากกว่า 300,000 บาท / ตรม.)',
      link: `${baseUrl}tag/super-luxury-class/`,
    },
  ],
};
